import { render, staticRenderFns } from "./loan-rejection.vue?vue&type=template&id=2d58135e&"
import script from "./loan-rejection.vue?vue&type=script&lang=js&"
export * from "./loan-rejection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports